import type { BetaCohort, Nav4RolloutBeta } from '../../../types.tsx';

export const getNav4RolloutForBetaCohort = (cohort: BetaCohort) => (): Nav4RolloutBeta => ({
	stage: 'beta',
	cohort,
});
